module.exports = __webpack_public_path__ + "static/media/smooth.4ff844cc.png";